import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { EyebrowComponent } from '../eyebrow/eyebrow.component';

/**
 * R-FORM-01 — section divider: eyebrow + horizontal rule. Used by EditSection and ViewSection.
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'bodyanalytics-section-rule',
  standalone: true,
  imports: [EyebrowComponent],
  templateUrl: './section-rule.component.html',
  styleUrls: ['./section-rule.component.scss'],
})
export class SectionRuleComponent {
  readonly label = input.required<string>();
}
